import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';

import Modal from 'common/components/modal';

const useStyles = makeStyles(theme => ({
  modalWrapper: {
    '& .ant-modal-body': {
      padding: '0 32px 32px',

      '& .ant-descriptions-item-label': {
        padding: '9.25px 17px',
        color: theme.colors.bodyColor,
        backgroundColor: theme.colors.gray3,
      },

      '& .ant-descriptions-item-content': {
        color: theme.colors.bodyColor,
        padding: '9.25px 17px',
      },
    },

    '& .ant-modal-footer': {
      '& .ant-btn-primary': {
        borderColor: theme.colors.gray5,
        color: theme.colors.bodyColor,
      },
      '& .ant-btn-danger': {
        backgroundColor: '#f5222d',
        borderColor: '#f5222d',
      },
      '& .ant-btn-background-ghost': {
        fontFamily: "'Avenir Next W04', 'Avenir Next', helvetica, arial, sans-serif",
        boxShadow: 'none',

        '& span': {
          fontWeight: 400,
        },
      },
    },
  },

  desc: {
    ...theme.typography.body2,
    fontFamily: "'Avenir Next W04', 'Avenir Next', helvetica, arial, sans-serif",
    display: 'inline-block',
    marginBottom: 20,
    marginTop: -4,
    color: theme.colors.bodyColor,
  },
}));

const RevokeModal = ({ revokeToken, revokeVisible, handleOpenOrCloseRevokeModal, t }) => {
  const classes = useStyles();

  return (
    <Modal
      visible={revokeVisible}
      okText={t('cms.dashboard.landlord.details.token.revoke_token_modal.ok_text')}
      width={454}
      title={t('cms.dashboard.landlord.details.token.revoke_token_modal.title')}
      wrapClassName={classes.modalWrapper}
      onCancel={handleOpenOrCloseRevokeModal}
      onOk={revokeToken}
      okButtonProps={{ type: 'danger' }}
    >
      <span className={classes.desc}>
        {t('cms.dashboard.landlord.details.token.revoke_token_modal.desc')}
      </span>
    </Modal>
  );
};

RevokeModal.propTypes = {
  t: PropTypes.func.isRequired,
  revokeToken: PropTypes.func.isRequired,
  revokeVisible: PropTypes.bool.isRequired,
  handleOpenOrCloseRevokeModal: PropTypes.func.isRequired,
};

export default RevokeModal;
